<template>
  <div class="a251">

    <!-- Hero -->
    <section class="a251__hero">
      <div class="a251__hero-bg" :style="{ backgroundImage: `url('https://www.songhancapital.com/assets/image/background_6.jpg')` }">
        <div class="a251__hero-overlay"></div>
        <div class="a251__hero-panel">
          <span class="a251__hero-badge">{{ $t('blog.article251120.badge') }}</span>
          <h1 class="a251__hero-title">{{ $t('blog.article251120.heroTitle') }}</h1>
          <p class="a251__hero-lead">{{ $t('blog.article251120.heroLead') }}</p>
        </div>
      </div>
    </section>

    <!-- Article -->
    <main class="a251__main">
      <div class="a251__shell">

        <article class="a251__article a251__fade">
          <h2 class="a251__article-title">{{ $t('blog.article251120.heroTitle') }}</h2>
          <p class="a251__para">{{ $t('blog.article251120.thank1') }}</p>
          <p class="a251__para">{{ $t('blog.article251120.thank2') }}</p>
          <p class="a251__para">{{ $t('blog.article251120.thank3') }}</p>
          <p class="a251__para a251__para--italic">{{ $t('blog.article251120.thank4') }}</p>

          <!-- Gallery -->
          <div class="a251__gallery">
            <div
              v-for="(img, i) in images"
              :key="i"
              class="a251__gallery-item"
              @click="openImageModal(img)"
            >
              <img v-if="img.src" :src="img.src" :alt="img.title || ''" class="a251__gallery-img" />
              <div v-else class="a251__gallery-block" :style="{ background: img.bg }"></div>
            </div>
          </div>
        </article>

        <!-- Contact CTA -->
        <div class="a251__cta a251__fade">
          <h2 class="a251__cta-title" @click="goToContact">{{ $t('common.contactNow') }}</h2>
          <div class="a251__cta-grid">
            <a href="https://t.me/songhancapital" target="_blank" rel="noopener noreferrer" class="a251__cta-btn a251__cta-btn--tg">
              <i class="fab fa-telegram-plane"></i>
              <div>
                <strong>{{ $t('common.telegram') }}</strong>
                <span>@SHC Rim</span>
              </div>
            </a>
            <a href="tel:+84766726416" class="a251__cta-btn a251__cta-btn--phone">
              <i class="fas fa-phone"></i>
              <div>
                <strong>{{ $t('common.tel') }}</strong>
                <span>+84.766.726.416</span>
              </div>
            </a>
          </div>
        </div>

        <!-- Product promo -->
        <div class="a251__promo a251__fade" @click="goToContact">
          <div class="a251__promo-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
            </svg>
          </div>
          <div class="a251__promo-body">
            <h3 class="a251__promo-title">{{ $t('blog.blog1.product') }}</h3>
            <p class="a251__promo-desc">{{ $t('blog.blog1.learn') }}</p>
            <div class="a251__promo-checks">
              <span><i class="fas fa-check"></i> {{ $t('common.safe') }}</span>
              <span><i class="fas fa-check"></i> {{ $t('common.profit') }}</span>
            </div>
          </div>
          <a href="/blog/dau-tu-an-toan-loi-nhuan-on-dinh-cung-ea-shc" class="a251__promo-btn">
            {{ $t('common.findOutNow') }}
            <i class="fas fa-arrow-right"></i>
          </a>
        </div>

      </div>
    </main>

    <!-- Image modal -->
    <div v-if="showImageModal" class="a251__modal" @click="closeImageModal">
      <div class="a251__modal-box" @click.stop>
        <button class="a251__modal-close" @click="closeImageModal">
          <i class="fas fa-times"></i>
        </button>
        <img v-if="selectedImage.src" :src="selectedImage.src" :alt="selectedImage.title || ''" class="a251__modal-img" />
        <div v-else class="a251__modal-block" :style="{ background: selectedImage.bg }">
          <h4>{{ selectedImage.title }}</h4>
          <p>{{ selectedImage.subtitle }}</p>
        </div>
        <div class="a251__modal-caption">
          <p>{{ selectedImage.caption }}</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script src="./251120.js"></script>
<style src="./251120.scss" lang="scss"></style>
